import React, { useState, useEffect } from 'react';
import { bannerConfig, getActiveBanners } from '../config/banners';
import { useLanguage } from '../context/LanguageContext';

const Banner = () => {
  const [currentBanner, setCurrentBanner] = useState(0);
  const { language } = useLanguage();

  // Aktif bannerları al
  const banners = getActiveBanners();

  useEffect(() => {
    if (banners.length === 0) return;

    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, bannerConfig.changeInterval);

    return () => clearInterval(interval);
  }, [banners.length]);

  const handleBannerClick = () => {
    // Banner'a tıklandığında ilgili sayfaya yönlendir
    if (banners.length > 0) {
      window.location.href = banners[currentBanner].link;
    }
  };

  // Banner yoksa component'i render etme
  if (banners.length === 0) {
    return null;
  }

  const currentBannerData = banners[currentBanner];
  const bannerText = currentBannerData.translations?.[language] || currentBannerData;

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-accent-orange to-gold">
      {/* Banner Container */}
      <div 
        className="text-white py-2 px-4 cursor-pointer transition-all duration-300 hover:from-accent-orange/90 hover:to-gold/90"
        onClick={handleBannerClick}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-center">
          <div className="flex items-center space-x-3">
            <span className="text-lg">{bannerText.title.split(' ')[0]}</span>
            <span className="text-lg font-body opacity-90">
              {bannerText.description}
            </span>
          </div>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white/20">
        <div 
          className="h-full bg-white/60 transition-all duration-100 ease-linear"
          style={{ 
            width: `${((currentBanner + 1) / banners.length) * 100}%` 
          }}
        />
      </div>
    </div>
  );
};

export default Banner;
